/**
 * Initialize the 'ui.modals' state.
 *
 * @type {Object}
 */
const INITIAL_STATE = {};

export default INITIAL_STATE;
